import type { TrendItemContentTweetsItem } from './trendItemContentTweetsItem';

/**
 * 트렌드 관련 콘텐츠
 */
export type TrendItemContent = {
  tweets?: TrendItemContentTweetsItem[];
};
